import type { HomeLog } from '@racepointenergy/swc/scs/types'
import { FormattedMessage, useIntl } from 'react-intl'

import { Home } from 'features/home/types'
import { SpinnerCentered } from 'components/Loader'
import HomeLogsTable from '../HomeLogsTable'
import { HomeLogsSpinnerContainer, StyledLogsInnerContainer } from '../styles'
import { WhiteBlock } from 'components/Layout'
import { homeLogsMessages } from '../messages'

interface HomeLogsInnerProps {
  home: Home
  data: HomeLog[]
  isFetching: boolean
  unsupportedMacHostVersion: boolean
  unsupportedLinuxHostVersion: boolean
  monitorAccessEnabled: boolean
}

function HomeLogsInner({
  home,
  data,
  isFetching,
  unsupportedMacHostVersion,
  unsupportedLinuxHostVersion,
  monitorAccessEnabled,
}: HomeLogsInnerProps) {
  const { formatMessage } = useIntl()

  const hostType = home.hostType

  if (unsupportedMacHostVersion) {
    return (
      <WhiteBlock bigPadding>
        <FormattedMessage {...homeLogsMessages.notSupportedMac} />
      </WhiteBlock>
    )
  }
  if (unsupportedLinuxHostVersion) {
    return (
      <WhiteBlock bigPadding>
        {formatMessage(homeLogsMessages.notSupportedOther, {
          hostType,
        })}
      </WhiteBlock>
    )
  }

  if (!monitorAccessEnabled) {
    return (
      <WhiteBlock bigPadding>
        <FormattedMessage {...homeLogsMessages.monitoringDisabled} />
      </WhiteBlock>
    )
  }

  if (isFetching) {
    return (
      <StyledLogsInnerContainer>
        <HomeLogsSpinnerContainer>
          <SpinnerCentered size="40" />
        </HomeLogsSpinnerContainer>
      </StyledLogsInnerContainer>
    )
  }

  return (
    <StyledLogsInnerContainer>
      {data?.length === 0 ? (
        <WhiteBlock bigPadding>
          {formatMessage(homeLogsMessages.noLogs, {
            btnTextRequestNew: formatMessage(homeLogsMessages.requestNew),
          })}
        </WhiteBlock>
      ) : (
        <HomeLogsTable data={data} />
      )}
    </StyledLogsInnerContainer>
  )
}

export default HomeLogsInner
